import {http, HttpResponse} from 'msw';

import {WatermarkSamplePhotoResponseBody} from '../types';

const samplePhotoMock: WatermarkSamplePhotoResponseBody = {
  content: '/9j/4AAQSkZJRgABAQ==',
  width: 500,
  height: 313,
};

const getWatermarkSamplePhotoHandler = http.get('*/dms/v2/sales/watermark/sample-photo', () =>
  HttpResponse.json(samplePhotoMock)
);

export const watermarkApiMock = {
  samplePhotoMock,
  getWatermarkSamplePhotoHandler,
};
